import { style } from '@/styles/globals';
import { useSafeLayoutEffect } from '@/utils/hooks/use-safe-layout-effect';
import { pr } from '@/utils/pxToRem';
import CloseIcon from '@mui/icons-material/Close';
import React, {
  useCallback, useEffect,
} from 'react';
import Select, {
  ActionMeta, InputActionMeta, SingleValue, components,
} from 'react-select';
// import { LocationSearchType } from '../../containers/SearchFlightTab/SearchDialog/index.d';
import { useAppSelector } from '../../utils/hook';
import type { CustomSelectProps } from './index.d';

const IndicatorSeparator = () => <></>;

const DropdownIndicator = () => <></>;

const Input = (props: any) => (
  <components.Input
    {...props}
    maxLength={50}
  />
);

const CustomSelect: React.FC<CustomSelectProps> = ({
  value,
  Control,
  onChange,
  onInputChange,
  onExit,
  lang,
  // locationType,
}) => {
  const [localInputValue, setLocalInputValue] = React.useState<string>('');
  const currentArea = useAppSelector((state) => state.area.currentArea);

  const onClearText = () => {
    handleInputChange('', {
      action: 'input-change',
      prevInputValue: localInputValue,
    });
  };

  const handleInputChange = useCallback(
    (newValue: string, actionMeta: InputActionMeta) => {
      if (actionMeta.action === 'input-change') {
        setLocalInputValue(newValue);
        if (onInputChange) {
          onInputChange(newValue, actionMeta);
        }
      }
    },
    [],
  );
  const handleOnChange = (
    newValue: SingleValue<any>,
    actionMeta: ActionMeta<any>,
  ) => {
    if (actionMeta.action === 'clear') {
      setLocalInputValue('');
    }
    if (onChange) {
      onChange(newValue, actionMeta);
    }
  };

  useEffect(() => () => onExit(), []);
  useSafeLayoutEffect(() => {
    if (value) {
      setLocalInputValue('');
    }
  }, [value]);
  useEffect(() => {
    if (currentArea) {
      setLocalInputValue(currentArea);
      if (onInputChange) {
        onInputChange(currentArea);
      }
    }
  }, [currentArea]);

  return (
    <div style={{
      position: 'relative',
      padding: '0px 16px',
    }}
    >
      <Select
        instanceId={localInputValue || currentArea}
        components={{
          Input,
          Control,
          IndicatorSeparator,
          DropdownIndicator,
        }}
        autoFocus
        isClearable
        isSearchable
        closeMenuOnSelect={false}
        styles={{
          clearIndicator: (
            base,
            state,
          ): any => ({
            ...base,
            cursor: 'pointer',
            color: state.isFocused ? 'blue' : 'black',
          }),
          valueContainer: (base: any) => ({
            ...base,
            flexWrap: 'nowrap',
            overflow: 'unset',
            fontSize: '0.875rem !important',
            padding: '0px 0px 0px 8px !important',
            color: `${style.color.black3} !important`,
            // fontFamily: '"Circular Regular","Helvetica","Arial",sans-serif',
          }),
          placeholder: (base) => ({
            ...base,
            color: `${style.color.black3} !important`,
            fontSize: '0.875rem',
          }),
          singleValue: (base) => ({
            ...base,
            color: `${style.color.black3} !important`,
            fontSize: '0.875rem',
          }),
          input: (base) => ({
            ...base,
            color: '#AAAAAA',
            fontSize: '16px!important',
          }),
          control: (base: any) => ({
            ...base,
            flexWrap: 'nowrap',
            overflow: 'auto',
            marginBottom: pr`16px`,
            minWidth: '241px',
          }),
        }}
        inputValue={localInputValue}
        // value={value ? { label: value.location, value: value.location } : null}
        placeholder={lang?.SearchBar?.flightsTab?.enterPlaceHolder || 'Nhập thành phố/tỉnh, quận/huyện, sân bay'}
        onChange={handleOnChange}
        onInputChange={handleInputChange}
        menuIsOpen={false}
      />
      {(localInputValue ? (
        <CloseIcon
          style={{
            zIndex: 99,
            position: 'absolute',
            right: '28px',
            top: '14px',
            width: '16px',
            height: '16px',
            background: style.color.black4,
            borderRadius: '50px',
            color: '#ffffff',
          }}
          onClick={() => {
            onClearText();
          }}
        />
      ) : null)}
    </div>
  );
};
export default CustomSelect;
